import { useEffect, useState } from "react";
import { Ifilter } from "../../../interfaces/IFilter";
import { IPaginacionComponent } from "../../../interfaces/base/ITable";
import { IGuardia } from "../../../interfaces/IGuadia";
import GuardiaService from "../../../services/guardiaService";

const UseProgramacionGuardia = () => {
    const [loadingTabla, setLoadingTabla] = useState<boolean>(false);
    const [items, setItems] = useState<IGuardia[]>([]);
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 50,
        search: "",
        CodigoTipoProgramacion: ""
    });

    const initial: Ifilter = {
        skip: 0,
        take: 50,
        search: ""
    };

    const onChangeTake = (take: number) => {
        setFilter({ ...filter, take: take, skip: 0 });
    };
    const onSkip = (skip: number) => {
        setFilter({ ...filter, skip: skip });
    };

    const [pagination, setPagination] = useState<IPaginacionComponent>({
        isLoading: loadingTabla,
        onChangeTake: onChangeTake,
        onChangeSkip: onSkip,
        totalPagesPagination: 10,
        skipPagination: filter.skip,
        takePagination: filter.take ?? 0,
        isVisible: true,
        total: 0,
    });

    const handleResetUpdate = () => {
        setFilter(initial);
    };

    const getRoster = () => {
        setLoadingTabla(true);
        GuardiaService.allGuardia(filter)
            .then((res) => {
                const pag: IPaginacionComponent = {
                    isLoading: loadingTabla,
                    onChangeTake: onChangeTake,
                    onChangeSkip: onSkip,
                    totalPagesPagination: res.data.pages,
                    skipPagination: filter.skip,
                    takePagination: filter.take ?? 0,
                    isVisible: true,
                    actualPage: res.data.page,
                    total: res.data.total,
                };
                setPagination(pag);
                setLoadingTabla(false);
                setItems(res.data.items);
            })
            .catch((e: any) => {
                setLoadingTabla(false);
            });
    };

    const onChangeSearch = (event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => {
        setFilter({ ...filter, skip: 0, search: newValue })
    }

    useEffect(() => {
        if (filter) {
            getRoster();
        }
    }, [filter]);

    return {
        items,
        filter,
        setFilter,
        loadingTabla,
        pagination,
        handleResetUpdate,
        onChangeSearch
    }
}

export { UseProgramacionGuardia }